// Reference letters & testimonials - migrated client recommendation letters
// Original .tif files converted to web-optimised JPG + WebP

export const REFERENCES = [
  {
    id: "manchester-city",
    client: "Manchester City Football Club",
    role: "Football Club / Sport",
    quote: "Pie in the Sky Productions delivered with the kind of professionalism and creative discipline that's rare in this industry. From the first call to the final delivery, every step was handled with precision - and the work speaks for itself.",
    contact: "",
    year: "2023",
    image: "/references/manchester-city.jpg",
    imageWebp: "/references/manchester-city.webp",
    thumb: "/references/manchester-city-thumb.jpg",
    relatedProject: "man-city-feature",
    sector: "Sport",
    featured: true,
  },
  {
    id: "roche",
    client: "Roche",
    role: "Pharmaceutical / Healthcare",
    quote: "The Pie in the Sky team produced our healthcare content to the highest standard - sensitive subject matter handled with empathy, regulator-aware storytelling, and broadcast-quality finishing. A trusted production partner.",
    contact: "",
    year: "2023",
    image: "/references/roche.jpg",
    imageWebp: "/references/roche.jpg",
    thumb: "/references/roche-thumb.jpg",
    relatedProject: "roche-feature",
    sector: "Healthcare",
    featured: true,
  },
  {
    id: "stellenbosch-university",
    client: "Stellenbosch University",
    role: "Higher Education",
    quote: "Pie in the Sky captured the spirit of our institution in a way that resonates deeply with students, staff and alumni. Reliable, creative, and a pleasure to work with.",
    contact: "",
    year: "2022",
    image: "/references/stellenbosch-university.jpg",
    imageWebp: "/references/stellenbosch-university.webp",
    thumb: "/references/stellenbosch-university-thumb.jpg",
    relatedProject: "su-feature",
    sector: "Education",
    featured: true,
  },
  {
    id: "general-recommendation",
    client: "General Recommendation",
    role: "Independent Reference",
    quote: "Working with Pie in the Sky Productions has been an exceptional experience. Their attention to detail, creative vision and professionalism set them apart. I highly recommend their services.",
    contact: "",
    year: "2023",
    image: "/references/general-recommendation.jpg",
    imageWebp: "/references/general-recommendation.webp",
    thumb: "/references/general-recommendation-thumb.jpg",
    relatedProject: null,
    sector: "General",
    featured: false,
  },
];

export const REVIEW_QUOTES = [
  {
    text: "Working with Pie in the Sky Productions was an incredible experience. Their attention to detail and creativity truly set them apart. I highly recommend their video production services.",
    name: "Adam Johnson",
    role: "Project Manager",
    source: "Google",
    rating: 5,
  },
  {
    text: "They turned our brief into something we couldn't have imagined. The team is fast, sharp, and obsessed with the craft - exactly what we needed.",
    name: "Sarah Naidoo",
    role: "Marketing Lead, Hospitality Group",
    source: "Direct client",
    rating: 5,
  },
  {
    text: "Professionalism from kickoff to wrap. Cinematic eye, real strategic thinking, and zero drama on set. They're our go-to in Cape Town.",
    name: "International Brand Manager",
    role: "FMCG",
    source: "Reference letter",
    rating: 5,
  },
  {
    text: "They captured the spirit of our institution in a way that resonated with students, staff and alumni. Reliable, creative, and a pleasure to work with.",
    name: "Stellenbosch University",
    role: "Higher Education",
    source: "Reference letter",
    rating: 5,
  },
  {
    text: "Sensitive healthcare content handled with empathy and broadcast-quality finishing. A trusted production partner.",
    name: "Roche",
    role: "Pharmaceutical",
    source: "Reference letter",
    rating: 5,
  },
  {
    text: "Professionalism and creative discipline that's rare in this industry. Every step handled with precision.",
    name: "Manchester City FC",
    role: "Sport / Football",
    source: "Reference letter",
    rating: 5,
  },
];
